// extracted by mini-css-extract-plugin
export default {"hinttitle":"src-components-atoms-hint-title-hint-title-module__hinttitle--sSe8J"};